export { InlineContactModule } from './InlineContactModule';
